import { registerSW } from "virtual:pwa-register";

const CHECK_EVERY_MS = 30 * 60 * 1000;

// Runs outside React and before i18n is ready, so the two strings live here.
const TEXT = navigator.language?.toLowerCase().startsWith("en")
  ? { message: "A new version is available", action: "Update" }
  : { message: "Hay una versión nueva", action: "Actualizar" };

/**
 * Registers the service worker and, when a new version has been deployed,
 * shows a small banner offering to reload. It never reloads on its own, so a
 * note being typed is not lost. Checks for a new version every 30 minutes, as
 * sales reps keep the CRM open all day.
 */
export const registerUpdatePrompt = () => {
  if (!("serviceWorker" in navigator)) return;

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      showBanner(() => updateSW(true));
    },
    onRegisteredSW(_url, registration) {
      if (registration) {
        setInterval(() => registration.update(), CHECK_EVERY_MS);
      }
    },
  });
};

const showBanner = (onUpdate: () => void) => {
  if (document.getElementById("update-prompt")) return;
  const banner = document.createElement("div");
  banner.id = "update-prompt";
  banner.setAttribute("role", "status");
  banner.className =
    "fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg bg-foreground px-4 py-2.5 text-sm text-background shadow-lg";
  const message = document.createElement("span");
  message.textContent = TEXT.message;
  const button = document.createElement("button");
  button.type = "button";
  button.textContent = TEXT.action;
  button.className =
    "rounded-md bg-primary px-3 py-1 font-medium text-primary-foreground";
  button.addEventListener("click", onUpdate);
  banner.append(message, button);
  document.body.append(banner);
};
